var lib_core = require("lib-core");

var SwitcherView = function(model, stateMachine, parentView, name, theme, multiLevel, config) {
    var self = this;

    this.model = model;
    this.stateMachine = stateMachine;
    this.template = parentView.getSwitcher(name, config.canNotEdit);
    this.template.multiLevel = multiLevel;  //TODO for Thijs: hack to let switcher know to use multilevel style

    this.template.clearItems();
    if(theme) this.template.setTheme(theme);

    this.model.visible.onChange('visibleOnChange', function(value, old){
        if(value){
            self.template.show();
        }else{
            self.template.hide();
        }
        // force redraw editor
        $(window).resize();
    }, 10);

    if(this.model.visible()){
        self.template.show();
    }else{
        self.template.hide();
    }

    this.model.items.onAdd({}, function(idx, item){
         self.addItem(item, idx);
    });
    this.model.items.forEach(function(idx, item) {
        self.addItem(item, idx);
    });
    // TODO add onSwap handler: when items in collection changed positions, view needs to be updated as well
    if(!config.canNotEdit){
        this.connectDeleteButton();
    }
};

SwitcherView.prototype.getTemplate = function() {
    return this.template;
};

SwitcherView.prototype.getYield = function () {
    return this.template.getYield();
};

SwitcherView.prototype.addItem = function(item, idx){
    var self = this;

    // build view
    var itemView = this.template.addItem(item.level, idx, item.getTitle(), item.getThumbnailURL(), item);
    item.selected.onChange({}, function(value){
        if (value) itemView.setActive();
        else itemView.setInactive();
    });

    if(item.selected())
        itemView.setActive();
    else
        itemView.setInactive();

    // Event listener
    itemView.$el.on('Cioui:SwitcherItem:clicked', function(e, val) {
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.SWITCHER_CLICK)
            .element(item)
            .scope(self.model.scope());
        self.stateMachine.handle(cEvent);
    });

    // Add children:
    item.subItems.forEach(function(idx, subItem){
        self.addItem(subItem, idx); // TODO maybe subItems view needs to be added to parentItem view instead of flat adding it to the switcher
    });
    item.subItems.onAdd({}, function(idx, subItem){
        self.addItem(subItem, idx);
    });
    // TODO add onSwap handler: when items in collection changed positions, view needs to be updated as well

    // remove item
    item.onDie({}, function(o){
        itemView.remove();
    });
};

SwitcherView.prototype.connectDeleteButton = function(){
    var self = this;

    // Event listener
    this.getTemplate().$el.on('Cioui:SwitcherDelete:clicked', function(e, val) {
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.SWITCHER_DELETE)
            .scope(self.model.scope());
        self.stateMachine.handle(cEvent);
    });
};

module.exports = SwitcherView;